import ClonePage from "./component/ClonePage";
import SVGLoader from "./assets/SVGLoader";

function App() {
  return (
    <div className="App">
      <SVGLoader />
      <ClonePage />
    </div>
  );
}

export default App;
